import { CSSProperties } from 'react';
import logo64 from '../images/logo64.png';

export const Logo64 = ({ className, style }: { className?: string; style?: CSSProperties }) => (
  <img src={logo64} className={className} alt='Enzo logo' style={style ?? {}} />
);
